// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from "react";
import SwapRightOutlinedSvg from "@ant-design/icons-svg/lib/asn/SwapRightOutlined";
import AntdIcon from "../components/AntdIcon";
const SwapRightOutlined = (props, ref)=>/*#__PURE__*/ React.createElement(AntdIcon, {
        ...props,
        ref: ref,
        icon: SwapRightOutlinedSvg
    });
if (process.env.NODE_ENV !== "production") {
    SwapRightOutlined.displayName = "SwapRightOutlined";
}
export default /*#__PURE__*/ React.forwardRef(SwapRightOutlined);
